/*
  Helper to create a react element for a tag (span, p, etc.) with either the innerHTML set to the argument (if a string)
  or dangerouslySetInnerHTML if an object with __html prop.
 */

import { createElement } from 'react';

export default function htmlElement(tag, text, props) {
  const localProps = text
    ? typeof text === 'object' && text.__html
      ? { ...props, dangerouslySetInnerHTML: text }
      : props
    : props;
  return createElement(tag, localProps, typeof text === 'string' ? text : null);
}
